import { render, staticRenderFns } from "./child_email_title.vue?vue&type=template&id=8aa23ed0&scoped=true&"
import script from "./child_email_title.vue?vue&type=script&lang=js&"
export * from "./child_email_title.vue?vue&type=script&lang=js&"
import style0 from "./child_email_title.vue?vue&type=style&index=0&id=8aa23ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa23ed0",
  null
  
)

export default component.exports